const parts = [`item`];

const baseStyle = {
  item: {
    color: `heading`,
    display: `flex`,
    alignItems: `center`,
  },
};

export const List = {
  parts,
  baseStyle,
};
